import React, { useEffect } from "react";
import { Label, Input, FormGroup, Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import HomeHyperlinks from "./home-hyperlinks";

const STOP_PREFIX = "{STOP}";
const hasStopPrefix = (text) =>
  !!text && text.toUpperCase().startsWith(STOP_PREFIX);
const stripStopPrefix = (text) =>
  hasStopPrefix(text) ? text.substring(STOP_PREFIX.length).trimStart() : text;
// No configured answers means this question is a dead end, same as NextQuestionId 0
const isTerminalAnswer = (curA, curAall) =>
  !curAall || curAall.length === 0 || (!!curA && (curA.NextQuestionId === 0 || hasStopPrefix(curA.TellCaller)));

export default function HomeQA(props) {
  const [answerTexts, setAnswerTexts] = React.useState({});
  useEffect(() => {
    //console.log("HomeQA=>", props);
  }, []);

  // allQ is nulled out on every reset/new problem selection (clearQuestionAnswer) - clear stale per-question answers with it
  useEffect(() => {
    if (!props.allQ) {
      setAnswerTexts({});
    }
  }, [props.allQ]);

  useEffect(() => {
    if (hasStopPrefix(props?.curA?.TellCaller)) {
      props.setAlerts(stripStopPrefix(props.curA.TellCaller), "danger");
    }
  }, [props.curA]);


  return (
    <>
      {props.allQ && props.allQ.length > 0 ? (
        <div
          className={
            props.fstate.problemtype &&
              props.fstate.problemtype.problemtypeq &&
              props.fstate.problemtype.problemtypeq
              ? "rectangleWarning"
              : "rectangle"
          }
        >
          {props.curQ ? (
            <FormGroup>
              <Label> {props.translate(props.lang, "Question")}:</Label>{" "}
              <span
                className="textarea"
                id="question"
                role="textbox"
                aria-label={props.translate(props.lang, "Question")}
              >
                {props.curQ.Question}
              </span>
            </FormGroup>
          ) : (
            ""
          )}

          {props.curAall && props.curAall.length > 0 ? (
            <FormGroup>
              <Label>{props.translate(props.lang, "Answer")}:</Label>
              {props.curAall[0].AnswerFormat !== "FREETEXT" &&
                props.curAall[0].AnswerFormat !== "DATE" ? (
                <Input
                  type="select"
                  value={props.curA ? props.curA.AnswerId : ""}
                  onChange={(e) => {
                    props.onSelectAnswer(e);
                  }}
                >
                  <option value=""></option>
                  {props.curAall.map((a) => (
                    <option key={a.AnswerId} value={a.AnswerId}>
                      {a.Answer}
                    </option>
                  ))}
                </Input>
              ) : (
                ""
              )}

              {(props.curAall[0].AnswerFormat === "FREETEXT") ? (

                //          <Input
                //              type="text"
                //  autoComplete="on"
                //  id={props.curA.AnswerId}
                //  name={props.curA.AnswerId}
                //              key={props.curA.AnswerId}
                //              valid={props.Answer.length!=0}
                //              invalid={props.Answer.length == 0}
                //              onChange={(e) => {
                //               //   setAnswer(e.target.value);
                //    props.onSelectAnswer(e);
                //  }}
                ///>
                <div style={{ position: 'relative' }}>
                  <span className="textareaEdit form-control" id={props.curAall[0].AnswerId} role="textbox" contentEditable
                    name={props.curAall[0].AnswerId}
                    key={props.curAall[0].AnswerId}
                    ref={(el) => {
                      if (!el) return;
                      const savedText = answerTexts[props.curQ.QuestionId] || "";
                      if (el.textContent !== savedText) {
                        el.textContent = savedText;
                      }
                      if (savedText.length > 0) {
                        el.classList.add("is-valid");
                        el.classList.add("form-control");
                      }
                    }}
                    style={{ paddingRight: '70px', minHeight: '38px', display: 'block' }}
                    onKeyDown={(e) => {
                        if (e.key.length === 1 && !e.ctrlKey && !e.metaKey &&
                            e.currentTarget.textContent.length >= 50) {
                            e.preventDefault();
                        }
                    }}
                    onPaste={(e) => {
                        e.preventDefault();
                        const remaining = 50 - e.currentTarget.textContent.length;
                        if (remaining <= 0) return;
                        const text = (e.clipboardData || window.clipboardData).getData('text/plain');
                        document.execCommand('insertText', false, text.substring(0, remaining));
                    }}
                    onInput={(e) => {
                      let text = e.currentTarget.textContent;
                      const questionId = props.curQ.QuestionId;
                      setAnswerTexts((prev) => ({ ...prev, [questionId]: text }));

                      if (text.length > 0) {
                        e.currentTarget.classList.add("is-valid");
                        e.currentTarget.classList.add("form-control");
                      } else {
                        e.currentTarget.classList.remove("is-valid");
                        e.currentTarget.classList.remove("form-control");
                      }

                      props.onSelectAnswer(e, true);
                    }} >
                  </span>

                  <div style={{
                    position: 'absolute',
                    right: '27px',
                    bottom: '10px',
                    fontSize: '0.875rem',
                    color: '#6c757d',
                    pointerEvents: 'none',
                    userSelect: 'none'
                  }}>
                    {(answerTexts[props.curQ.QuestionId] || "").length} / 50
                  </div>
                </div>

              ) : (
                ""
              )}

              {props.curAall[0].AnswerFormat === "DATE" ? (
                <Input
                  type="date"
                  name="date"
                  id={props.curAall[0].AnswerId}
                  placeholder=""
                  // Restores the previously picked date (e.g. after Back/Next/edit) since the answer object is kept between visits
                  value={
                    props.curA &&
                      props.curA.AnswerId === props.curAall[0].AnswerId &&
                      props.curA.Answer &&
                      props.curA.Answer.toLowerCase() !== "date"
                      ? props.curA.Answer
                      : ""
                  }
                  className={
                    props.curA &&
                      props.curA.AnswerId === props.curAall[0].AnswerId &&
                      props.curA.Answer &&
                      props.curA.Answer.toLowerCase() !== "date"
                      ? "is-valid"
                      : ""
                  }
                  onChange={(e) => {
                    let val = e.target.value.toString();


                    if (val && val.toLowerCase() != "date") {
                      e.currentTarget.classList.add("is-valid");
                      e.currentTarget.classList.add("form-control");

                    } else {
                      e.currentTarget.classList.remove("is-valid");
                      e.currentTarget.classList.remove("form-control");
                    }
                    props.onSelectAnswer(e);
                  }}
                />
              ) : (
                ""
              )}
            </FormGroup>
          ) : (
            ""
          )}

          {props.curA &&
            props.curA.TellCaller &&
            props.curA.TellCaller.length > 0 ? (

            <FormGroup>
              <HomeHyperlinks tellCaller={stripStopPrefix(props.curA.TellCaller)} id={"tellcaller" + props.curA.QuestionId}></HomeHyperlinks>
            </FormGroup>
          ) : (
            ""
          )}
          {props.curQ ? (
            <div
              className="qa-nav-buttons"
              style={{
                display: "flex",
                justifyContent:
                  props.selectedQA && props.selectedQA.length > 0
                    ? "space-between"
                    : "flex-end",
                alignItems: "center",
              }}
            >
              {props.selectedQA && props.selectedQA.length > 0 ? (
                <Button
                  color="secondary"
                  onClick={(e) => {
                    props.prevQA(e);
                  }}
                >
                  {props.translate(props.lang, "Back")}
                </Button>
              ) : (
                ""
              )}
              
              {!(hasStopPrefix(props?.curA?.TellCaller))?(
              <Button
                color="info"
                onClick={(e) => {
                  if (!props.curA || props.curA.Answer !== "Date") {
                    props.nextQA(e);
                  }
                }}
              >
                {props.translate(
                  props.lang,
                  isTerminalAnswer(props.curA, props.curAall) ? "Done" : "Next"
                )}
              </Button>
):("")}

            </div>
          ) : (
            ""
          )}

          {!props.curQ &&
            !props.curA &&
            props.selectedQA &&
            props.selectedQA.length > 0
            ? props.selectedQA.map((a, index) => (
              <FormGroup key={props.Guid()}>
                <Label>
                  <span className="qa-label" key={props.Guid()}>
                    {props.translate(props.lang, "Question")}:
                  </span>
                </Label>
                <span className="qa-input" key={props.Guid()}>{a.Question}</span>
                <FontAwesomeIcon
                  icon={faPencilAlt}
                  className="qa-edit-icon"
                  title={props.translate(props.lang, "Edit")}
                  onClick={() => {
                    props.editQA(index);
                  }}
                />
                <p>
                  <Label>
                    <span className="qa-label" key={props.Guid()}>
                      {props.translate(props.lang, "Answer")}:
                    </span>
                  </Label>
                  <span className="qa-input" key={props.Guid()}>{a.Answer}</span>
                </p>
                {a.TellCaller && a.TellCaller.length > 0 ? (
                  <p>
                    <HomeHyperlinks tellCaller={stripStopPrefix(a.TellCaller)} id={"tellcaller" + a.QuestionId}></HomeHyperlinks>
                  </p>
                ) : (
                  ""
                )}
              </FormGroup>
            ))
            : ""}
        </div>
      ) : (
        ""
      )}



    </>
  );
}
